<template>
  <div class="mc-image-slider" v-if="data.images.length > 0">
    <swiper
        wrapperTag="ul"
        :modules="modules"
        :pagination="{enabled: true, clickable: true, el: '.swiper-pagination'+uniqueId}"
        class="mc-image-slider__wrapper"
        wrapperClass="mc-image-slider__list">
      <swiper-slide v-for="item in data.images" class="mc-image-slider__item" tag="li">
        <router-link :to="item.url">
        <picture class="mc-image-slider__picture">
          <img loading="lazy"  class="mc-image-slider__image" :src="item.src" width="360" height="360" alt="">
        </picture>
        </router-link>
      </swiper-slide>
      <template v-slot:container-end><span><div :class="'swiper-pagination swiper-pagination'+uniqueId"></div></span></template>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper';

export default {
  name: 'SliderBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modules: [Pagination, Navigation],
      uniqueId: 'slider-' + Math.random().toString(36).substring(2, 9) // Generate unique ID for navigation elements
    };
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
</script>